import { LABELS } from "~/resources/Labels";
import { getComponentNumber } from "~/Utils/Utils";
import { ComponentRequest } from "~/models/Commons ";
import { UseVmComponentsForm } from "./vm-configuration/UseVmComponentsForm";
import { SIMPLDialog } from "../../../components/commons/dialog/SimplDialog";
import { SIMPLInput } from "../../../components/commons/input/SIMPLInput";
import { SIMPLButtonCustomized } from "../../../components/commons/button/SIMPLButtonCustumized";
import { useTranslation } from "react-i18next";


type DialogProps = {
  onSuccess?: (title: string, message: string, response: any) => void;
  onError?: (title: string, message: string) => void;
};
export type VmComponentType =
  | "vm-configuration"
  | "post-provisioning-operations"
  | "policies";

interface VmFormConfig {
  componentType: VmComponentType; // restringido aos valores válidos
  contentLabel: string; // label do textarea
  contentMessage: string; // mensagem de erro do textarea
}

interface Prop {
  onCloseModal: () => void;
  setConfig: Function;
  refetch: () => void;
  title?: string;
  config: VmFormConfig;
  dialogProps: DialogProps;
  placeholder?: string;
  messageRequired?: string;
}

export const AddVmGeneric = ({
  onCloseModal,
  setConfig,
  refetch,
  title,
  config,
  dialogProps: { onSuccess, onError },
  placeholder,
  messageRequired
}: Prop) => {

  const { handleSubmit, control, errors, isValid, isLoading, submitForm } = UseVmComponentsForm(
    onCloseModal,
    refetch,
    onSuccess,
    onError,
  );
const {t} = useTranslation();
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit((formData: ComponentRequest) => {
      submitForm(formData, getComponentNumber(config.componentType));
    })(event);

    setConfig({ key: "", direction: LABELS.ASC });
  };

  const renderButtons = () => (
    <>
      <div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label={t("Cancel")}
          secondary
          buttonHandlerAction={onCloseModal}
        />
      </div>
      <div className="grow-0 basis-32">
        <SIMPLButtonCustomized label={t("Submit")} primary disabled={!isValid || isLoading} />
      </div>
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={title!}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
      showLine
    >
      <div className="flex justify-center">
        <div className="w-[500px]">
          <div className="flex flex-col w-full gap-y-4">
            <SIMPLInput
              name="name"
              control={control}
              rules={{
                required: { value: true, message: LABELS.NameRequired },
              }}
              messageRequired={t("NameRequired")}
              label={t("Name")}
              placeholder={t("Name")}
              required
              id="name"
              fontWeight="bold"
              errorLabel={errors.name?.message}
              testId="component-name"
            />
            <SIMPLInput
              name="description"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t("MessagesDescriptionRequired"),
                },
              }}
              messageRequired={t("MessagesDescriptionRequired")}
              required
              label={t("Description")}
              id="description"
              fontWeight="bold"
              errorLabel={errors.description?.message}
              placeholder={t("Description")}
              testId="component-description"
            />
            <SIMPLInput
              name="content"
              control={control}
              type="textarea"
              rows={4}
              label={config.contentLabel}
              placeholder={placeholder}
              placeholderColor="placeholder:text-[#6B6F7B]"
              required
              rules={{
                required: { value: true, message: config.contentMessage },
              }}
              messageRequired={messageRequired ?? config.contentMessage}
              id="content"
              fontWeight="bold"
              errorLabel={errors.content?.message}
              testId="component-content"
            />
          </div>
        </div>
      </div>
    </SIMPLDialog>
  );
};